import angular from 'angular';
import Papa from 'papaparse';
import './globals';
import './tags'
import '../resources/tags-groups';
import { chunk, map, cloneDeep, countBy, isEmpty } from 'lodash';
import { spacesNotAllowed } from '../../src/utils/stringFormatting';

const module = angular.module('whyline.services.tags-groups', [
	'whyline.resources.tags-groups',
]);

let TagsGroups;

class TagsGroupsService {
	static $inject = ['TagsGroups'];

	constructor(
		injectedTagsGroups,
	) {
		TagsGroups = injectedTagsGroups;
	}

	GetAll() {
		return TagsGroups.FetchAll();
	}

	GetAllAsPromise() {
		return TagsGroups.FetchAll({
			promise: true,
		});
	}

	GetAllAsPromiseFromServer() {
		return TagsGroups.FetchAll({
			promise: true,
			force: true,
		});
	}

	GetOneAsPromiseFromServer(tagGroupId) {
		return TagsGroups.FindById(tagGroupId, {
			promise: true,
			force: true,
		});
	}

	Copy(tagGroup) {
		const copy = cloneDeep(tagGroup);
		return new TagsGroups(copy);
	}

	Create(data) {
		const newTagGroup = new TagsGroups(data);
		return TagsGroups.Save(newTagGroup);
	}

	Update(data, id) {
		const updatedTagGroup = new TagsGroups(data);
		return TagsGroups.Update(updatedTagGroup, id);
	}

	UpdateTags(groupId, tags) {
		return TagsGroups.UpdateTags(groupId, tags);
	}

	Enable(tagGroup) {
		return new TagsGroups(tagGroup).enable(!tagGroup.enabled);
	}


	validateCsv(headingNotSpace, rows) {

		if (headingNotSpace.length !== 2) {
			return {
				data: {
					httpCode: 409,
					message: 'incorrect-number-of-headers'
				}
			}
		}

		const count = countBy(headingNotSpace);
		const result = map(count, (v, k) => ({ name: k, count: v }));
		const res = result.filter(head => head.count > 1);

		if (res.length) {
			return {
				data: {
					httpCode: 409,
					message: 'duplicate-header'
				}
			}
		}

		const rowsWithData = rows.filter(row => !isEmpty(row))

		if (rowsWithData.length <= 1) {
			return {
				data: {
					httpCode: 409,
					message: 'csv-file-wrong-data'
				}
			}
		}

	}

	SplitFileInChunks(file, limit = 100) {
		let error = {};
		let _self = this;
		return new Promise(fullfill => {
			Papa.parse(
				file,
				{
					skipEmptyLines: true,
					header: true,
					beforeFirstChunk: function (chunk) {
						const rows = chunk.split(/\r\n|\r|\n/);
						const headings = rows[0].split(',');
						const headingNotSpace = headings.map(head => spacesNotAllowed(head));
						error = _self.validateCsv(headingNotSpace, rows);
						return rows.join('\n');
					},
					complete: results => fullfill({
						rowsCount: results.data.length,
						chunks: chunk(results.data, limit),
						error
					}),
				}
			);
		});
	}

	async Sync(file, limit, action) {
		const { rowsCount, chunks, error } = await this.SplitFileInChunks(file, limit);
		if (!isEmpty(error)) {
			throw error;
		}
		const tasks = map(chunks, chunkRowsToUpload => () => TagsGroups.Sync(chunkRowsToUpload, action, file.name.split('.').pop()));
		return { tasks, rowsCount };
	}
}

module.exports = module.service('TagsGroupsService', TagsGroupsService);
